import React from "react";
import NoData from "src/components/Shared/LoadingAnimations/NoData";
import Preloader from "src/components/Shared/LoadingAnimations/Preloader";

export default function TableBodyLoader({ dataExists = false, loaded = true, colSpan = "5" }) {
  let isLoadedWithNoData = () => loaded && !dataExists;

  return (
    <>
      {isLoadedWithNoData() && (
        <tr>
          <td colSpan={colSpan}>
            <NoData />
          </td>
        </tr>
      )}
      {!loaded && !dataExists && (
        <tr>
          <td colSpan={colSpan}>
            <Preloader color="text-slate-400 fill-slate-700" />
          </td>
        </tr>
      )}
    </>
  );
}
